var _rect, _rect2, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36A6A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36A6A4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.0001C0.280051 10.2846 -2.16667 10.6667 -3 11.0001V13.5C-1.83333 13.5 0.631789 14.0439 2 14.5C8 16.5 11 15 13 12.5C14.8019 10.2476 18.6667 4.16667 20 1L12.5 -1.5L10 6.5C9.16667 8.33336 8 12 3.5 11.0001Z",
    fill: "#179593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.5001C7.28005 17.7846 -0.666667 17.6667 -1.5 18L0 19.5C1.16667 19.5 7.5 20.5 9 22C13.4721 26.4721 18 22.5 20 20C21.8019 17.7476 25.6667 11.6667 27 8.5L23 4L17.5 14C16 16 15 19.5 10.5 18.5001Z",
    fill: "#179593"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3 6C9.58203 6 9 6.58203 9 7.3V15.1C9 15.818 9.58203 16.4 10.3 16.4H14.2C14.918 16.4 15.5 15.818 15.5 15.1V7.3C15.5 6.58203 14.918 6 14.2 6H10.3ZM12.25 15.1C12.609 15.1 12.9 14.809 12.9 14.45C12.9 14.091 12.609 13.8 12.25 13.8C11.891 13.8 11.6 14.091 11.6 14.45C11.6 14.809 11.891 15.1 12.25 15.1Z",
    fill: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.8410b085d5602d09ed5b5db6b7d7ee83.svg";
export { ForwardRef as ReactComponent };